import { BasePage } from '@/components/ui/base-page'

export function RSUPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add RSUPage specific content here */}
    </BasePage>
  )
}